module.exports = __webpack_public_path__ + "assets/img/ty7.d44f532d.jpg";